import i18n from '@/i18n';

import { ToastNotification } from '../components/ToastNotification/ToastNotification';

import { Playdeck } from './playdeck';

import coinPng from '/img/tgem.png';
import coinWebp from '/img/tgem.webp';

interface OpentTgInvoiceOptionType {
  errorMessage?: {
    text?: string;
    image?: {
      img: string;
      webp?: string;
    };
  };
  onSuccess?: () => void;
  onError?: () => void;
  playdeckRequestPayload?: {
    amount: number;
    description: string;
    externalId: string;
  };
}

const openTgInvoice = (
  link: string,
  options?: OpentTgInvoiceOptionType,
): void => {
  if (options?.playdeckRequestPayload) {
    Playdeck.requestPayment(options.playdeckRequestPayload);
  }
  Telegram.WebApp.openInvoice(link, (status) => {
    if (status === 'cancelled' || status === 'failed') {
      ToastNotification(
        i18n.t(
          options?.errorMessage?.text ||
            'Something went wrong, please try again',
        ),
        {
          img: options?.errorMessage?.image?.img || coinPng,
          webp: options?.errorMessage?.image
            ? options?.errorMessage?.image?.webp
            : coinWebp,
        },
      );

      if (options?.onError) {
        options.onError();
      }
    }

    if (status === 'paid' && options?.onSuccess) {
      options.onSuccess();
    }
    console.log(`payment status ${status}`);
  });
};

export { openTgInvoice };
